import { defineMessages } from 'react-intl'

const scope = `procurify.components.TaxSelect`

export default defineMessages({
  selectTaxPlaceholder: {
    id: `${scope}.selectTaxPlaceholder`,
    defaultMessage: 'Select tax',
  },
  defaultTaxLabel: {
    id: `${scope}.defaultTaxLabel`,
    defaultMessage: 'Default',
  },
  addNewTaxOptionLabel: {
    id: `${scope}.addNewTaxOptionLabel`,
    defaultMessage: '+ Add new tax',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  noTaxOptionLabel: {
    id: `${scope}.noTaxOptionLabel`,
    defaultMessage: 'No tax',
  },
  customAmountOptionLabel: {
    id: `${scope}.customAmountOptionLabel`,
    defaultMessage: 'Custom amount ($)',
  },
  customPercentageOptionLabel: {
    id: `${scope}.customPercentageOptionLabel`,
    defaultMessage: 'Custom percentage (%)',
  },
  customOptionGroupLabel: {
    id: `${scope}.customOptionGroupLabel`,
    defaultMessage: 'Custom',
  },
  presetOptionGroupLabel: {
    id: `${scope}.presetOptionGroupLabel`,
    defaultMessage: 'Presets',
  },
  legacyPresetTaxLabel: {
    id: `${scope}.legacyPresetTaxLabel`,
    defaultMessage: 'Legacy preset',
  },
})
